import cx from "classnames";
import { CTA } from "common/styleguide/CTA";
import { ModalOverlay } from "common/styleguide/ModalOverlay";
import blueTheme from "common/styleguide/ModalOverlay/blueHeaderModalTheme.scss";
import fetchJSON from "lib/fetchJSON";
import { commonCTAs, Msg, useFormatMessage } from "lib/localization";
import { introText } from "lib/styleguide/base.scss";
import { getPreferences } from "lib/utils";
import querystring from "querystring";
import React, { useState } from "react";
import { defineMessages, FormattedMessage as T } from "react-intl";
import styles from "./PlannerOnboardingModal.scss";
import { descriptions, descriptionsValues, tips, titles } from "./tips";

const params = querystring.parse(window.location.search.substring(1));
const defaultDismissed = (getPreferences()["planner-onboarding-dismissed"] ?? false) && !params.onboarding;

const messages = defineMessages({
  title: {
    id: "PlannerOnboardingModal.title",
    defaultMessage: "Welcome to the Route Planner",
  },
});

export const PlannerOnboardingModal = (props) => {
  const fm = useFormatMessage();
  const [activeTip, setActiveTip] = useState(0);
  const [dismissed, setDismissed] = useState(defaultDismissed);

  const onRequestClose = () => {
    fetchJSON("/set_preference.json", {
      key: "planner-onboarding-dismissed",
      value: true,
    });
    setDismissed(true);
  };

  const nextClicked = () => {
    setActiveTip((activeTip + 1) % tips.length);
  };

  if (dismissed) {
    return null;
  }

  const tip = tips[activeTip];
  const title = titles[tip.key];
  const description = descriptions[tip.key];

  const button =
    activeTip >= tips.length - 1 ? (
      <div>
        <CTA link inline margins={false} onClick={() => setActiveTip(0)}>
          <T id="PlannerOnboardingModal.showMeAgain" defaultMessage="Show me again" />
        </CTA>
        <CTA inline margins={false} onClick={onRequestClose}>
          <Msg capitalized m={commonCTAs.done} />
        </CTA>
      </div>
    ) : (
      <CTA margins={false} inline onClick={nextClicked}>
        <Msg capitalized m={commonCTAs.next} />
      </CTA>
    );

  const pips = tips.map((tip, index) => (
    <span
      className={cx(styles.pip, activeTip === index && styles.current)}
      onClick={() => setActiveTip(index)}
      key={tip.gif}
    />
  ));

  return (
    <ModalOverlay
      className={styles.PlannerOnboardingModal}
      maxWidth="800px"
      shouldCloseOnOverlayClick
      title={fm(messages.title)}
      onRequestClose={onRequestClose}
      footer={<div className={styles.ctaContainer}>{button}</div>}
      theme={blueTheme}
    >
      <div className={styles.TipsCarousel}>
        <div className={styles.imgContainer}>
          <img src={tip.gif} />
        </div>
        <p className={styles.title}>
          <Msg m={title} />
        </p>
        <p className={introText}>
          <T {...description} values={descriptionsValues} />
        </p>
        <div>{pips}</div>
      </div>
    </ModalOverlay>
  );
};
